var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00905189 10.1444C0.0419032 10.3663 0.145807 10.5722 0.305731 10.7333L9.06764 19.6214C9.26221 19.8459 9.54335 19.9823 9.84435 19.9984C10.1456 20.0145 10.4403 19.9091 10.659 19.7067C10.8778 19.5046 11.001 19.2234 11 18.9298C10.999 18.6359 10.8737 18.3557 10.6534 18.1548L2.60991 10L10.6534 1.84518C10.8737 1.6443 10.999 1.36407 11 1.0702C11.001 0.776575 10.8778 0.495351 10.659 0.293254C10.4402 0.0908923 10.1456 -0.0145079 9.84435 0.00161109C9.54335 0.0177301 9.2622 0.154123 9.06765 0.37856L0.305731 9.26665C0.0752616 9.50026 -0.0339814 9.82315 0.00930655 10.1443L0.00905189 10.1444Z",
    fill: "#E3E5F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4af02682406788c4d6e536ad2f9ed8b8.svg";
export { ForwardRef as ReactComponent };